<template>
  <div>
    <CreateForm />
  </div>
</template>
<script>
import CreateForm from "./CreateForm.vue";
export default {
  components: {
    CreateForm
  }
};
</script>
